/**
 * Old constants for auth0
 */

export const AUTH_COOKIE_NAME = 'auth_jwt';
export const LOCK_SECRET_NAME = 'lock_uuid';
export const REFERRER_COOKIE_NAME = 'referrer';
export const USER_COOKIE_NAME = 'auth_user';
export const USER_DISPLAY_NAME_COOKIE_NAME = 'auth_user_display_name';
export const FAR_FUTURE_DATE = '2063-04-05';

/**
 * New Constants for cognito
 */

// This is the maximum amount of time that the user can go
// without refreshing before they will need to log back in.
export const MAX_REFRESH_TIME = 365 * 24 * 60 * 60 * 1000;
export const COGNITO_LAST_RETURN_URL = 'auth_cog_returnUrl';
